import {api, apiGateway} from "api/config";
import { AxiosResponse } from "axios";

import { queryParamsToString } from "utils/requestHelpers/requestHelpers";
import type { ITaskFromServer } from "./models";

type ITasksResponse = AxiosResponse<{data: {items: ITaskFromServer[], total: number}, error: string[], success: boolean}>

class tasksService {

    getTasks(params: {[key: string]: string | number}): Promise<ITasksResponse> {
        let query = '';

        if(params) {
            query = queryParamsToString(params);
        }

        // return api.get(`https://sm/api/v2/seller/tasks?${query}`);
        return api.get(`${apiGateway.legacyPublicAPIv2}/seller/tasks?${query}`);
    }

    getTaskById(id: string | number) {
        // return api.get(`https://sm/api/v1/tasks/${id}`)
        return api.get(`${apiGateway.legacyPublicAPIv1}/tasks/${id}`)
    }

    async createNewTask<T>(data: T) {
        console.log('createNewTask', JSON.stringify(data));

        return api(`${apiGateway.legacyPublicAPIv1}/seller/tasks`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    async repeatTask<T>(sellerId: number, taskId: number) {
        const reqData = {task: taskId, seller: sellerId}
        console.log('repeatTask', JSON.stringify(reqData));

        return api(`${apiGateway.legacyPublicAPIv1}/tasks/repeat`, {
        // return api(`https://sm/api/v1/tasks/repeat`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(reqData)
        })
    }

    async doReaction<T>(sellerId: number, taskId: number, reactionType: string, action: string, data: object) {
        const reqData = {
            task: taskId,
            seller: sellerId,
            reactionType: reactionType,
            action: action,
            data: data
        }
        console.log('doReaction', JSON.stringify(reqData));

        return api(`${apiGateway.legacyPublicAPIv1}/tasks/do-reaction`, {
        // return api(`https://sm/api/v1/tasks/do-reaction`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(reqData)
        })
    }

    async stopTask<T>(sellerId: number, taskId: number) {
        const reqData = {task: taskId, seller: sellerId}
        console.log('stopTask', JSON.stringify(reqData));

        return api(`${apiGateway.legacyPublicAPIv1}/tasks/stop`, {
        // return api(`https://sm/api/v1/tasks/stop`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(reqData)
        })
    }
}

export default new tasksService();
